import { keepPreviousData } from "@tanstack/react-query";

const FIVE_MINUTES = 2 * 60 * 1000; // 3 minutes in milliseconds

// react query cache and refetch options
export const reactQueryCacheAndRefetchOptions = {
  // refetchOnWindowFocus: false, // Always refetch when tab/window becomes active
  // refetchOnMount: true,
  // refetchOnReconnect: true,
  // staleTime: FIVE_MINUTES, // Data is fresh for 3 minutes
  // refetchInterval: FIVE_MINUTES, // Auto refetch every 3 minutes
  // placeholderData: keepPreviousData,
  // retry: false,

  refetchOnWindowFocus: false,
  refetchOnMount: true,
  refetchOnReconnect: false,
  staleTime: Infinity,
  refetchInterval: false,
  placeholderData: keepPreviousData,
  retry: false,
};
